import { replace } from '@seedcloud/ramda-extra'

export const formatPilotCategories = (pilotCategory) =>
  `${replace(/_/g, ' ', pilotCategory)}`
